(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('action-commands', {
                parent: 'management',
                url: '/action-commands/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.actionCommands.home.title'
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/action-commands/action-commands.html',
                        controller: 'ActionCommandsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('tabActionsQueue');
                        $translatePartialLoader.addPart('Queue');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('commands-detail', {
                parent: 'action-commands',
                url: '/commands-detail',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.actionCommands.commandsDetail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/action-commands/commands-detail.html',
                        controller: 'CommandsDetailController',
                        controllerAs: 'vm'
                    }
                },
                params:{
                    objectUniqueCode: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('tabActionsQueue');
                        $translatePartialLoader.addPart('Queue');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabActions', function ($stateParams, TabActions) {
                        return TabActions.command({id: $stateParams.id});
                    }],
                    objectUniqueCode: ['$stateParams', function ($stateParams) {
                        return $stateParams.objectUniqueCode;
                    }]
                }
            });
    }

})();
